import { forwardRef } from "react";
import { cn } from "../../lib/cn.js";
import { inputVariants } from "../../lib/variants.js";

const Input = forwardRef(
  (
    {
      className,
      variant = "default",
      size = "md",
      error,
      success,
      disabled = false,
      ...props
    },
    ref
  ) => {
    const baseClasses = "w-full bg-white text-[var(--color-warm-900)] placeholder:text-[var(--color-warm-400)] border rounded-xl px-4 transition-colors outline-none disabled:bg-[var(--color-warm-100)] disabled:cursor-not-allowed";
    
    let finalVariant = variant;
    if (error) finalVariant = "error";
    if (success) finalVariant = "success";
    
    const variantClasses = inputVariants.variant[finalVariant] || inputVariants.variant.default;
    const sizeClasses = inputVariants.size[size] || inputVariants.size.md;
    
    return (
      <input
        ref={ref}
        className={cn(
          baseClasses,
          variantClasses,
          sizeClasses,
          className
        )}
        disabled={disabled}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";

export default Input;